import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { formatCurrency } from "../../../../../helpers";
import { useStoreListObject } from "../../../../../hooks/useStoreListObject";

export const PriceSummary = ({ gRForm = {} }) => {
  const { storeMap } = useStoreListObject();

  return (
    <div className={`${globalStyles.cardWithBorder} white`}>
      {/* <h4 className="font-weight-normal">Price Summary</h4> */}

      <div className="d-flex justify-content-between">
        <p>Total</p>
        <h5 className="purple--text mb-0">
          {formatCurrency({
            value: gRForm?.items?.reduce((acc, item) => {
              return (acc +=
                item?.cost_price * Number(item?.quantity_received));
            }, 0),
            currencyCode:
              storeMap?.[gRForm?.items?.[0]?.store_id]?.currency_code,
          })}
        </h5>
      </div>
    </div>
  );
};
